// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ca65bbcc","453":"cb2cf0fd","455":"1b4b6d7d","977":"f7544f29"}[chunkId] + ".chunk.js";
};